"use strict";

var _classCallCheck = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tx_1 = require("@ethereumjs/tx");

var ethereumjs_util_1 = require("ethereumjs-util");

var Utils_1 = require("@opengsn/common/dist/Utils");

var RelayedTransactionValidator = /*#__PURE__*/function () {
  function RelayedTransactionValidator(contractInteractor, logger, config) {
    _classCallCheck(this, RelayedTransactionValidator);

    this.contractInteractor = contractInteractor;
    this.config = config;
    this.logger = logger;
  }
  /**
   * Decode the signed transaction returned from the Relay Server, compare it to the
   * requested transaction and validate its signature.
   * @returns a signed {@link Transaction} instance for broadcasting, or null if returned
   * transaction is not valid.
   */


  _createClass(RelayedTransactionValidator, [{
    key: "validateRelayResponse",
    value: function validateRelayResponse(request, maxAcceptanceBudget, returnedTx) {
      var tx = tx_1.Transaction.fromSerializedTx(ethereumjs_util_1.toBuffer(returnedTx), this.contractInteractor.getRawTxOptions());
      var transaction = Object.assign({
        signer: tx.getSenderAddress().toString()
      }, tx.toJSON());

      if (transaction.to == null) {
        throw new Error('transaction.to must be defined');
      }

      if (transaction.s == null || transaction.r == null || transaction.v == null) {
        throw new Error('tx signature must be defined');
      }

      this.logger.debug("returnedTx: ".concat(JSON.stringify(transaction, null, 2)));
      var signer = transaction.signer;
      var externalGasLimit = transaction.gasLimit;
      var relayRequestAbiEncode = this.contractInteractor.encodeABI(maxAcceptanceBudget, request.relayRequest, request.metadata.signature, request.metadata.approvalData, externalGasLimit);
      var relayHubAddress = this.contractInteractor.getDeployment().relayHubAddress;

      if (relayHubAddress == null) {
        throw new Error('no hub address');
      }

      if (Utils_1.isSameAddress(transaction.to, relayHubAddress) && relayRequestAbiEncode === transaction.data && Utils_1.isSameAddress(request.relayRequest.relayData.relayWorker, signer)) {
        this.logger.info('validateRelayResponse - valid transaction response');
        var receivedNonce = parseInt(transaction.nonce);

        if (receivedNonce > request.metadata.relayMaxNonce) {
          // TODO: need to validate that client retries the same request and doesn't double-spend.
          // Note that this transaction is totally valid from the EVM's point of view
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          throw new Error("Relay used a tx nonce higher than requested. Requested ".concat(request.metadata.relayMaxNonce, " got ").concat(receivedNonce));
        }

        return true;
      } else {
        console.error('validateRelayResponse: req', relayRequestAbiEncode, relayHubAddress, request.relayRequest.relayData.relayWorker);
        console.error('validateRelayResponse: rsp', transaction.data, transaction.to, signer);
        return false;
      }
    }
  }]);

  return RelayedTransactionValidator;
}();

exports.RelayedTransactionValidator = RelayedTransactionValidator;